export const formFullfill = (order) => {
    const elementsToInjectDataAsValue = [
        ...document.querySelectorAll('[data-order-inject-as-value]'),
    ];
    const elementsToInjectDataAsContent = [
        ...document.querySelectorAll('[data-order-inject-as-content]'),
    ];

    console.log(order);

    elementsToInjectDataAsValue.forEach((el) => {
        el.value = order[el.dataset.orderInjectAsValue];
        el.dispatchEvent(new Event('input'));
    });

    elementsToInjectDataAsContent.forEach((el) => {
        el.innerHTML = order[el.dataset.orderInjectAsContent];
        const parent = el.closest('.js-inject-as-content-parent');
        parent?.classList.remove('d-none');
    });
};
